import { throttle } from 'lodash-es'
export const PORTAL_SEARCH_HISTORY_LIST = 'PORTAL_SEARCH_HISTORY_LIST'
export const PORTAL_ROUTER_TAG_LIST = 'routerTags'

export const isVideo = path => {
  return /\.(mp4|avi|wmv|mpg|mpeg|mov|rm|ram|swf|flv)$/i.test(path)
}

export const generateVideoPoster = src =>
  `${src}?x-oss-process=video/snapshot,t_0,f_jpg,w_0,h_0,m_fast,ar_auto`

export const isImage = path => {
  return /\.(jpg|jpeg|png|gif|svg|webp|avif|jp)$/i.test(path)
}

export const isGif = path => {
  return /\.gif$/i.test(path)
}
export const isCR3 = path => {
  return /\.(CR3|cr3})$/i.test(path)
}

export const evalPropChain = (data, fieldChain) => {
  return new Function('obj', 'with(obj){return ' + fieldChain + ';}')(data)
}
export const observeDomResize = (node, callback, throttleTime = 300) => {
  const _callback = throttle(callback, throttleTime)
  const observer = new ResizeObserver(_callback)
  if (node && node instanceof Element) {
    observer.observe(node)
  } else {
    console.warn('Invalid element for ResizeObserver:', node)
  }
  return observer
}

/**
 * 只保留有用的key
 * @param {*} obj
 * @param {有用的keys} arr
 * @returns
 */
export const omitObjectKey = (obj, arr) =>
  Object.keys(obj)
    .filter(k => arr.includes(k))
    .reduce((acc, key) => ((acc[key] = obj[key]), acc), {})
export const insertHtmlResourceJs = arr => {
  arr.forEach(element => {
    const script = document.createElement('script')
    script.type = element.type || 'module'
    script.dataset.moduleId = element.id
    script.src = element.src
    document.head.appendChild(script)
  })
}
export const insertHtmlResourceCss = arr => {
  arr.forEach(element => {
    const link = document.createElement('link')
    link.rel = 'stylesheet'
    link.type = 'text/css'
    link.dataset.moduleId = element.id
    link.href = element.href
    document.head.appendChild(link)
  })
}
export const insertHtmlResourceFont = arr => {
  arr.forEach(element => {
    const link = document.createElement('link')
    link.rel = 'preload'
    link.crossorigin = 'anonymous'
    link.as = 'font'
    link.type = element.type || 'font/woff2'
    link.dataset.moduleId = element.id
    link.href = element.href
    document.head.appendChild(link)
  })
}
export const isNumber = val => {
  return parseFloat(val) !== 'NaN'
}
export const isStringEmpty = str => {
  return str === null || str === undefined || str === ''
}
export function translateDataToTree(data) {
  const parents = data.filter(
    value => value.parentId === 'undefined' || value.parentId == null
  )
  const children = data.filter(
    value => value.parentId !== 'undefined' && value.parentId != null
  )
  const translator = (parents, children) => {
    parents.forEach(parent => {
      parent.title = parent.name
      parent.value = parent.id
      children.forEach((current, index) => {
        if (current.parentId === parent.id) {
          const temp = JSON.parse(JSON.stringify(children))
          temp.splice(index, 1)
          translator([current], temp)
          typeof parent.children !== 'undefined'
            ? parent.children.push(current)
            : (parent.children = [current])
        }
      })
    })
  }
  translator(parents, children)
  return parents
}

export function isEqualObject(obj1, obj2) {
  if (!obj1 || !obj2 || typeof obj1 !== 'object' || typeof obj2 !== 'object') {
    return false
  }
  if (Object.keys(obj1).length !== Object.keys(obj2).length) {
    return false
  }
  for (let key in obj1) {
    if (!isEqualArray(obj1[key], obj2[key])) {
      return false
    }
  }
  return true
}

export function isEqualArray(arr1, arr2) {
  if (arr1.length !== arr2.length) {
    return false
  }
  for (let i = 0; i < arr1.length; i++) {
    if (arr1[i] !== arr2[i]) {
      return false
    }
  }
  return true
}

export function getTargetURL() {
  const { searchParams } = new URL(location.href)
  return searchParams.get('target')
}

export function getMFEPathname(url, code) {
  let { pathname, hash, search } = new URL(url)
  if (pathname === '/' && hash) {
    pathname = hash.slice(1)
  }

  return `/${code.toLowerCase()}${pathname}${search}`
}

export function getSubAppURL(code, pathname, mfeMap, newMenuList) {
  const origin = mfeMap[code.toUpperCase()]?.[0]
  const menu = newMenuList.find(
    item => item.menuCode?.toUpperCase() === code.toUpperCase()
  )
  if (menu) {
    const isHashMode =
      menu.menuPath.includes('/#') ||
      menu.childrenList.find(item => {
        if (item.menuPath.startsWith(origin)) {
          return item.menuPath.includes('/#/')
        }
      })
    if (origin) {
      const url = isHashMode ? `${origin}/#${pathname}` : `${origin}${pathname}`
      return url
    }
  }
  return ''
}

export function getIframeURL(code, pathname, mfeMap, newMenuList) {
  const url = getSubAppURL(code, pathname, mfeMap, newMenuList)
  if (url) {
    return location.origin + '/Iframe?target=' + url
  }
  return ''
}

export const setItem = (key, data, type) => {
  type === 'session'
    ? sessionStorage.setItem(key, JSON.stringify(data))
    : localStorage.setItem(key, JSON.stringify(data))
}

export const removeItem = (key, type) => {
  type === 'session'
    ? sessionStorage.removeItem(key)
    : localStorage.removeItem(key)
}

export const getItem = (key, type) => {
  const json =
    type === 'session' ? sessionStorage.getItem(key) : localStorage.getItem(key)
  return json ? JSON.parse(json) : null
}

export const getOrigin = url => {
  if (!url?.startsWith('http')) {
    return url
  }
  try {
    return new URL(url).origin
  } catch (error) {
    console.warn('Invalid URL:', url)
    return url
  }
}

export const getPathname = path => {
  if (!path) {
    return path
  }
  let pathname = ''
  let hash = ''
  if (path.startsWith('http')) {
    if (!/^(https?:\/\/)[^\s/$.?#].[^\s]*$/i.test(path)) {
      return ''
    }
    const obj = new URL(path)
    pathname = obj.pathname
    hash = obj.hash
    if (pathname === '/' && hash) {
      return hash.slice(1).split('?')[0]
    }
  } else {
    pathname = path
  }
  if (pathname.startsWith('#/')) {
    return pathname.slice(1).split('?')[0]
  } else if (pathname.startsWith('/#/')) {
    return pathname.slice(2).split('?')[0]
  }
  return pathname.split('?')[0]
}

export const onLocalStorageChange = event => {
  if (event.key === 'MFE_CODE_ORIGIN_MAP') {
    const oldValue = JSON.parse(event.oldValue) || {}
    setItem('MFE_CODE_ORIGIN_MAP', oldValue, 'session')
    setTimeout(() => {
      location.reload()
    }, 100)
  }
}

export function isRouteInRoutes(targetPath, routes) {
  targetPath = normalizePath(targetPath)

  const matchRoute = (routeList, basePath = '') => {
    for (const route of routeList) {
      const fullPath = normalizePath(`${basePath}/${route.path}`)

      if (fullPath === targetPath) {
        return true
      }

      if (route.children?.length) {
        if (matchRoute(route.children, fullPath)) {
          return true
        }
      }
    }
    return false
  }

  return matchRoute(routes)
}

function normalizePath(path) {
  return path
    .replace(/\/+/g, '/')
    .replace(/\/$/, '')
    .toLowerCase()
}
